import React from 'react'
import styled from '@emotion/styled'
import { CONTENTFUL_KEYS, mediaQueriesByDevice } from 'parameters/index'
import { useAuthState } from 'services/Authentication'
import { useDashboardItems } from './lib/useDashboardItems'
import { DashboardGrid } from './grid'
import { FallbackProvider } from './fallbacks/context'
import { useLoginRequired } from 'services/Authentication/hooks/useLoginRequired'
import { InjectedContentfulProps, withContentful } from 'components/vendor/Contentful/withContentful'
import { useHasMounted } from 'lib/renderWrappers/ClientOnly'

const Dashboard: React.FC<React.PropsWithChildren<InjectedContentfulProps>> = ({ getValue }): JSX.Element => {
	const { profile } = useAuthState()
	useLoginRequired()
	const { dashboardGroups, fallbackItems } = useDashboardItems()
	const hasMounted = useHasMounted()
	const title = `${getValue(CONTENTFUL_KEYS.DASHBOARD.TITLE)}${
		profile.displayName && hasMounted ? `, ${profile.displayName}` : ''
	}`

	return (
		<DashboardWrapper>
			<Title>{title}</Title>
			<SubTitle>{getValue(CONTENTFUL_KEYS.DASHBOARD.SUBTITLE)}</SubTitle>
			<FallbackProvider fallbacks={fallbackItems}>
				<DashboardGrid content={dashboardGroups} />
			</FallbackProvider>
		</DashboardWrapper>
	)
}

export const DashboardComponent = withContentful(Dashboard)

const DashboardWrapper = styled.div`
	margin-bottom: 24px;
`

const Title = styled.h1`
	margin-bottom: 8px;
`

const SubTitle = styled.p`
	margin-bottom: 32px;

	${mediaQueriesByDevice.mobile} {
		margin-bottom: 12px;
	}
`

export type { DashboardGroup, DashboardItem } from './lib/types'
